import {useMemo} from "react";
import {useMe} from "./useGetUser";
import {useGetCatgeory, useGetSectors} from "./useCategory";

const useUserSectors = (anonymeData) => {
  const {data, isLoading: isLoadingUser} = useMe();
  const {data: categories, isLoading: isLoadingCategory} = useGetCatgeory();
  const {data: sectorsList, isLoading: isLoadingSectors} = useGetSectors();
  const subCategories = useMemo(
    () =>
      anonymeData?.SubCategories ?? data?.Technician?.SubCategories ?? [],
    [anonymeData?.SubCategories, data?.Technician?.SubCategories],
  );

  const {selectedCategories, selectedSectors} = useMemo(() => {
    if (!subCategories.length || !categories?.length || !sectorsList?.length) {
      return {selectedCategories: [], selectedSectors: []};
    }

    const uniqueCategories = new Map();
    const uniqueSectors = new Map();

    subCategories.forEach((subCategory) => {
      const categoryObject = categories.find(
        (category) => category.id === subCategory.fatherId,
      );
      const sectorObject = sectorsList.find(
        (sector) => sector?.id === categoryObject?.Sector?.id,
      );

      if (categoryObject) uniqueCategories.set(categoryObject.id, categoryObject);
      if (sectorObject) uniqueSectors.set(sectorObject.id, sectorObject);
    });

    return {
      selectedCategories: Array.from(uniqueCategories.values()),
      selectedSectors: Array.from(uniqueSectors.values()),
    };
  }, [categories, sectorsList, subCategories]);

  return {
    isLoading: isLoadingUser || isLoadingCategory || isLoadingSectors,
    subCategories,
    categories: selectedCategories,
    sectors: selectedSectors,
    sectorsList,
  };
};

export default useUserSectors;
